import classNames from 'classnames';
import { motion } from 'framer-motion';
import { FC, InputHTMLAttributes, ReactNode } from 'react';

import styles from './segmented-control.module.css';

type Option = {
    value: string
    label: ReactNode
} | string;

type Props = InputHTMLAttributes<HTMLInputElement> & {
    name: string
    options: Option[]
};

export const SegmentedControl: FC<Props> = ({ value, options, ...props }) => (
    <div className={classNames(styles['segmented-control__container'], {
        [styles['segmented-control__container--disabled']]: props.disabled,
    })}>
        {options.map((option) => (
            <label className={styles['segmented-control__option']} key={typeof option === 'string' ? option : option.value}>
                <input
                    {...props}
                    className={styles['segmented-control__radio']}
                    type="radio"
                    checked={value === (typeof option === 'string' ? option : option.value)}
                    value={typeof option === 'string' ? option : option.value}
                />
                <span className={classNames(styles['segmented-control__label'])}>
                    {typeof option === 'string' ? option : option.label}
                </span>
                {(value === (typeof option === 'string' ? option : option.value)) && <motion.span layout layoutId="selected" className={styles['segmented-control__highlight']} />}
            </label>
        ))}
    </div>
);
